export default "__VITE_ASSET__1wNIkt9v__"